import {ResponseError} from "./response-error";

export class VerEmailResponse {
  email: string = "";
  valor: boolean = false;
  error: ResponseError = new ResponseError();
}
